/**
 * Simple temp const stuff
 */
export const financialGroupTypeAndName = {
    // financial type index 0, financial group index 1
    BSA: [2, 1],
    BSL: [3, 1],
    BSE: [4, 1],
    PL: [1, 2],
    CF: [5, 3],
    DRVE: [6, 4],
    CUSTOM: [7, 5],
};

export const financialGroupNameFromFinancialType = {
    1: 'PL',
    2: 'BSA',
    3: 'BSL',
    4: 'BSE',
    5: 'CF',
    6: 'DRVE',
    7: 'CUSTOM',
};

export const financialGroupTypeFromName = {
    PL: 1,
    BSA: 2,
    BSL: 3,
    BSE: 4,
    CF: 5,
    DRVE: 6,
    CUSTOM: 7,
};

export const financialGroupTypes = {
    1: 'profitloss',
    2: ['balancesheet', 'assets'],
    3: ['balancesheet', 'liabilities'],
    4: ['balancesheet', 'equities'],
    5: 'cashflow',
    6: 'drivers',
    7: 'custom',
};
